<template>
  <div class="fill-height" style=" z-index: 1000">
    <v-data-table-virtual
      class="ma-0 point-table"
      :headers="reinforcementHeaders"
      :items="items"
      disable-sort
      disable-filtering
      disable-pagination
      hide-default-footer
      fixed-header
      density="compact"
    >
      <template #bottom></template>

      <template v-slot:[`header.name`]="{ header }">
        <div class="container">
          <span>{{ header }}</span>
          <v-btn
            variant="flat"
            size="x-small"
            color="primary"
            @click="addNewPoint({reinforcementId})"
            :disabled="isLocked"
          >
            <v-icon left small class="mr-0">
              mdi-plus
            </v-icon>
            Add
          </v-btn>
        </div>
      </template>

      <template v-slot:item="{ item }">
        <tr
          :key="item.id"
          @click="setCurrentItem(item)"
          @contextmenu.prevent="setCurrentItem(item); isLocked || show($event, item)"
        >
          <td
            class="pa-0"
            :style="`border-left: solid 5px ${currentReinforcementPoint === item ? $vuetify.theme.themes.light.primary : 'white'}`"
          >
            <v-text-field
              variant="plain"
              color="primary"
              @update:model-value="$event && onItemChanged({
                  parameter: 'geometry.coordinates.0',
                  item,
                  value: $event,
                })"
              full-width
              :class="[
                    'pa-0', 'mt-0', 'custom', 'text-field',
                    getDirtyClass(item, 'geometry.coordinates.0'),
                    isLocked ? 'disable-events' : '']"
              hide-details
              density="compact"
              type="number"
              :model-value="item.geometry.coordinates[0]"
            />
          </td>
          <td class="pa-0">
            <v-text-field
              variant="plain"
              color="primary"
              @update:model-value="$event && onItemChanged({
                  parameter: 'geometry.coordinates.1',
                  item,
                  value: $event,
                })"
              full-width
              :class="[
                    'pa-0', 'mt-0', 'custom', 'text-field',
                    getDirtyClass(item, 'geometry.coordinates.1'),
                    isLocked ? 'disable-events' : '']"
              hide-details
              density="compact"
              type="number"
              :model-value="item.geometry.coordinates[1]"
            />
          </td>
          <td>
            <v-select
              color="primary"
              variant="plain"
              @update:model-value="onItemChanged({
                  parameter: 'properties.name',
                  item,
                  value: $event,
                })"
              :class="[
                    'pa-0', 'mt-0' ,'custom',
                    getDirtyClass(item, 'properties.name'),
                    isLocked ? 'disable-events' : '']"
              hide-selected
              :clearable="!isLocked"
              clear-icon="mdi-close"
              :items="nameChoices"
              :model-value="item.properties.name"
              item-title="display_name"
              item-value="value"
              density="compact"
              :style="{
                  borderRadius: 0,
                  fontSize: '14px',
                  height: '100%',
                }"
              item-disabled="disabled"
              hide-details
            >
            </v-select>
          </td>
        </tr>
      </template>

      <template v-slot:no-data>
        <NoDataAvailableCenter />
      </template>
    </v-data-table-virtual>
    <TableActionMenu
      @update:show-menu="showMenu = $event"
      :show-menu="showMenu"
      :x="x"
      :y="y"
      @action="deleteItem(currentReinforcementPoint.id)"
      @add="addNewPoint({
          selectedPoint: currentReinforcementPoint,
          reinforcementId,
        })"
    />
  </div>
</template>

<script>

  import { mapActions, mapGetters, mapState } from "vuex"
  import DirtyFieldsMixIn from "@/mixins/DirtyFieldsMixIn.vue"
  import ShowActionMenuMixin from "@/mixins/ShowActionMenuMixin.vue"
  import TableActionMenu from "@/components/common/TableActionMenu.vue"
  import NoDataInDataTable from "@/components/common/NoDataInDataTable.vue"
  import NoDataAvailableCenter from "@/components/soilcomposition/NoDataAvailableCenter.vue"

  export default {
    name: "ReinforcementPointTable",
    components: { NoDataAvailableCenter, NoDataInDataTable, TableActionMenu },
    mixins: [DirtyFieldsMixIn, ShowActionMenuMixin],
    data: () => ({
      reinforcementHeaders: [
        {
          title: "X",
          value: "x",
          width: "20%",
          cellClass: "pa-0",
          class: "pa-0"
        },
        {
          title: "Y",
          value: "y",
          width: "20%",
          cellClass: "pa-0",
          class: "pa-0"
        },
        {
          title: "Name",
          value: "name",
          width: "60%",
          cellClass: "pa-0",
          class: "pa-0"
        }
      ]
    }),
    props: {
      reinforcementId: {
        required: true
      }
    },
    computed: {
      ...mapGetters("reinforcementPoint", {
        reinforcementPoints: "reinforcementPoints",
        nameChoices: "reinforcementPointNameChoices"
      }),
      ...mapState("reinforcementPoint", {
        currentReinforcementPoint: state => state.currentItem
      }),
      ...mapGetters("stabSchematisation", {
        isLocked: "isLockedCurrent"
      }),
      items () {
        return this.reinforcementPointById(this.reinforcementId)
      }
    },
    methods: {
      ...mapActions("reinforcementPoint", {
        add: "add",
        setNestedParameter: "setNestedParameter",
        setCurrentItem: "setCurrentItem",
        deleteReinforcementPoint: "deleteItem"
      }),
      addNewPoint ({ selectedPoint, reinforcementId }) {
        this.add({
          selectedPoint,
          reinforcementId,
          points: this.items
        })
      },
      reinforcementPointById (reinforcementId) {
        return this.reinforcementPoints(reinforcementId)
      },
      onItemChanged ({ parameter, item, value }) {
        this.addDirty(item, parameter)
        this.setNestedParameter({
          parameter: parameter,
          item,
          value
        })
      },
      deleteItem (reinforcementId) {
        this.deleteReinforcementPoint(reinforcementId)
        this.setCurrentItem(null)
      },
      emptyDirtyItemsClass () {
        this.dirtyItems = []
      }
    }
  }
</script>

<style scoped>
  .container {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .point-table {
    max-height: 30vh;
  }

  .custom input[type='number'] {
    -moz-appearance: textfield;
  }


  .custom.v-text-field.v-text-field--enclosed .v-input__slot {
    padding-left: 0 !important;
  }
</style>
